import {createApp} from 'vue'
import store from 'store'
import DeleteCancerProfileModal from './DeleteCancerProfileModal'
const el = '.kb-component--delete-cancer-profile-modal'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DeleteCancerProfileModalDOM) => {
            const props = {
                continueUrl: DeleteCancerProfileModalDOM.dataset.continueUrl,
                continueUrlWithData: DeleteCancerProfileModalDOM.dataset.continueUrlWithData,
            }
            const component = createApp(DeleteCancerProfileModal, props).use(Store)
            component.mount(DeleteCancerProfileModalDOM)
        })
    }
}